import MasterCrud from "@/components/app/MasterCrud";
import { IDR } from "@/lib/api";

export default function LaborTypes() {
  return (
    <MasterCrud
      endpoint="/labor-types"
      title="Tenaga Kerja & Tarif"
      description="Daftar jenis tenaga kerja langsung beserta tarif per jam."
      fields={[
        { key: "code", label: "Kode", type: "text", required: true },
        { key: "name", label: "Jenis Tenaga Kerja", type: "text", required: true },
        { key: "hourly_rate", label: "Tarif per Jam (IDR)", type: "number", required: true },
        { key: "description", label: "Deskripsi", type: "textarea" },
      ]}
      columns={[
        { key: "code", header: "Kode" },
        { key: "name", header: "Nama" },
        { key: "hourly_rate", header: "Tarif / jam", align: "right", render: (r) => <span className="font-semibold">{IDR(r.hourly_rate)}</span> },
      ]}
    />
  );
}
